import React, { useEffect, useState } from 'react'
import logoPrivadas from "../assets/images/ubicacionPrivadas.png"
import logoPatronales from "../assets/images/ubicacionPatronales.png"
import logoPublicas from "../assets/images/ubicacionPublicas.png"
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import { DetallesCapis } from '../utils/utils'


const MyMap = ({ height, width, styles, className }) => {
	const [capis, setCapis] = useState([]);
	const [selectedPosition, setSelectedPosition] = useState(null)

	const allFunctions = async () => {
		setCapis(await DetallesCapis());
	}

	useEffect(() => {
		allFunctions();
	}, []);

	const CenterMap = ({ position }) => {
		const map = useMap();
		useEffect(() => {
			if (position) {
				map.flyTo(position, 12); // Cambia el centro del mapa con una animación
			}
		}, [position, map]);
		return null;
	};
	const icons = {
		Privado: L.icon({
			iconUrl: logoPrivadas,
			iconSize: [38, 38],
		}),
		Patronal: L.icon({
			iconUrl: logoPatronales,
			iconSize: [38, 38],
		}),
		Publico: L.icon({
			iconUrl: logoPublicas,
			iconSize: [38, 38],
		})
	}


	return (
		<div>
			<MapContainer 
				center={[13.794599, -88.93]} 
				zoom={9} 
				className={className}
				style={{ height: height, width: width, ...styles }}
			>
				<TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
				<CenterMap position={selectedPosition} />
				{capis.map(capi => (
					<Marker
						key={capi.id_autorizacion}
						position={[capi.latitud, capi.longitud]}
						icon={icons[capi.naturaleza] || icons.Publico}
						eventHandlers={{
							click: () => {
								setSelectedPosition([capi.latitud, capi.longitud]);
								//   getSelectedCapi(capi.id_autorizacion);
							}
						}}
					>
						<Popup>
							{capi.nombre_establecimiento} <br />
							Tipo: {capi.naturaleza}
						</Popup>
					</Marker>
				))}
			</MapContainer>
		</div>
	)
}

export default MyMap
